/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/site';

export const getOrganizations =
	(): Promise<ApiResponse> => {
		return apiClient.get('/organizations', {
			params: {
				pageSize: 100,
				sort: 'name',
			},
		});
	};

export const useAllOrganizations = () => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['organizations'],
		queryFn: () => getOrganizations(),
	});

	return {
		data: data?.rows ? data?.rows : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
